import { render, staticRenderFns } from "./situationdetail.vue?vue&type=template&id=6ad0ec41&scoped=true&"
import script from "./situationdetail.vue?vue&type=script&lang=js&"
export * from "./situationdetail.vue?vue&type=script&lang=js&"
import style0 from "./situationdetail.vue?vue&type=style&index=0&id=6ad0ec41&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad0ec41",
  null
  
)

export default component.exports